"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealOmeletteFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealOmeletteFilled = function MealOmeletteFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24 20a1 1 0 10-2 0 3 3 0 01-3 3 1 1 0 100 2 5 5 0 005-5z",
    fill: "#97BA1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.114 11.166c-1.04-3.824-5.517-5.511-8.823-3.324-.574.38-1.24.597-1.927.629L14.5 8.7c-6.306.296-11.074 5.819-10.448 12.1a11.02 11.02 0 009.535 9.835l2.213.29a3.888 3.888 0 012.505 1.393l.42.515c2.849 3.482 8.44 2.3 9.636-2.037l.04-.14a3.354 3.354 0 013.232-2.462c4.91 0 7.23-6.057 3.576-9.337l-2.908-2.61a4.85 4.85 0 01-1.44-2.336l-.747-2.745zM26 20a7 7 0 11-14 0 7 7 0 0114 0z",
    fill: "#97BA1E"
  }));
};

exports.MealOmeletteFilled = MealOmeletteFilled;
var _default = MealOmeletteFilled;
exports.default = _default;